'use client'

import Script from 'next/script'
import { GA_MEASUREMENT_ID, GOOGLE_ADS_ID, DEBUG } from '@/lib/config'

/**
 * GoogleAnalytics Component
 *
 * Loads gtag.js once and configs GA4 and/or Google Ads. Mounted from the root
 * layout so every page gets both tags without a second script load.
 */
export default function GoogleAnalytics() {
  const gtagLoaderId = GA_MEASUREMENT_ID || GOOGLE_ADS_ID

  if (DEBUG) {
    console.log('[GA] Measurement ID:', GA_MEASUREMENT_ID || 'missing')
    console.log('[Google Ads] ID:', GOOGLE_ADS_ID || 'missing')
  }

  if (!gtagLoaderId) {
    if (DEBUG) {
      console.warn(
        'GA Measurement ID and Google Ads ID missing - gtag disabled. ' +
        'Set NEXT_PUBLIC_GA_MEASUREMENT_ID and/or NEXT_PUBLIC_GOOGLE_ADS_ID in your .env.local file.'
      )
    }
    return null
  }

  const configCalls = [
    GA_MEASUREMENT_ID && `gtag('config', '${GA_MEASUREMENT_ID}');`,
    GOOGLE_ADS_ID && `gtag('config', '${GOOGLE_ADS_ID}');`,
  ]
    .filter(Boolean)
    .join('\n          ')

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gtagLoaderId}`}
        strategy="afterInteractive"
      />
      
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          ${configCalls}
        `}
      </Script>
    </>
  )
}
